/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_3Inputs */

const es_chat_suggestions_welcome_3 = /** @type {(inputs: Chat_Suggestions_Welcome_3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listo cuando quieras, ${i?.name}. ¿Qué necesitás analizar?`)
};

const en_chat_suggestions_welcome_3 = /** @type {(inputs: Chat_Suggestions_Welcome_3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ready when you are, ${i?.name}. What do you need?`)
};

/**
* | output |
* | --- |
* | "Ready when you are, {name}. What do you need?" |
*
* @param {Chat_Suggestions_Welcome_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_3 = /** @type {((inputs: Chat_Suggestions_Welcome_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_3(inputs)
	return en_chat_suggestions_welcome_3(inputs)
});
export { chat_suggestions_welcome_3 as "chat.suggestions.welcome_3" }